import { ApiClient } from 'app/service/api-service'
import { RangeExperienceEndPoint } from './constant'

export const requestGetAllRangeExperienceManagement = () =>
  ApiClient.Get({
    url: `${RangeExperienceEndPoint.RangeExperienceManagement.request}/get-all`,
    params: {},
  })
